import { prop, reduceBy } from '@neo/ramda-extra'

export const mapToNotesViewModel = (notes) =>
  reduceBy(
    (acc, { formQuestionRef, ...note }) => acc.concat(note),
    [],
    prop('formQuestionRef'),
    notes
  )
